import './videocallInfo.component.scss';

// @vendor
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

// @components
import { OKLayoutMigration } from '../layout/OKLayoutMigration';
import { videocallInfoKeys } from './videocallInfo.component.poeditor';
import { OKMessage } from 'commonsComponents/OKMessage';
import { CommonError } from '../commonError/commonError.component';

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @hooks
import { useVideocallInfo } from './hooks/useVideocallInfo';

// @constants
import { CALL_STATUS } from '../../migrationUsersBranchView.constants';

const instructitons = [
  {
    title: videocallInfoKeys.bullet01Title,
    subtitle: videocallInfoKeys.bullet01Description,
  },
  {
    title: videocallInfoKeys.bullet02Title,
    subtitle: videocallInfoKeys.bullet02Description,
  },
  {
    title: videocallInfoKeys.bullet03Title,
    subtitle: videocallInfoKeys.bullet03Description,
  },
];

const bulletIcon = require('../../assets/bullet.svg');
const passportOpenedIcon = require('../../assets/ID _ Passport _ Opened.svg');
const passportClosedIcon = require('../../assets/ID _ Passport _ Closed.svg');
const documentFrontIcon = require('../../assets/ID _ Deutschland _ Front.svg');

export const VideocallInfo = ({ handleExitLeaveModal }) => {
  const { immProfile, handleContinue, result } = useVideocallInfo();

  return (
    <OKLayoutMigration
      header={{
        leftSideText: formatText(videocallInfoKeys.headerLeftText),
        exitButton: { handleClickButton: handleExitLeaveModal },
      }}
      footer={
        result === CALL_STATUS.ERROR
          ? undefined
          : {
              rightSideButton: {
                loading: result === CALL_STATUS.IN_PROGRESS,
                disabled: result === CALL_STATUS.IN_PROGRESS,
                text: formatText(videocallInfoKeys.continueButton),
                handler: handleContinue,
              },
            }
      }
    >
      {result === CALL_STATUS.ERROR ? (
        <CommonError handleOnClick={handleContinue} />
      ) : (
        <div>
          <div className="migration-videocall-info__image-text">
            <div className="migration-videocall-info__image-container">
              <img
                className="migration-videocall-info__image-container--primary"
                src={documentFrontIcon}
              />
              <div>
                <img
                  className="migration-videocall-info__image-container--secondary"
                  src={passportClosedIcon}
                />
                <img
                  className="migration-videocall-info__image-container--secondary"
                  src={passportOpenedIcon}
                />
              </div>
            </div>
            <div className="migration-videocall-info__title">
              <FormattedText
                value={videocallInfoKeys.title}
                injectedStrings={[immProfile.get('nombreCliente')]}
              />
            </div>
          </div>
          <div className="migration-videocall-info__instructions-container">
            {instructitons.map((element, _index) => (
              <Fragment key={element.title}>
                <div className="migration-videocall-info__instructions-container--item">
                  <img
                    className="migration-videocall-info__instructions-container--bullet"
                    src={bulletIcon}
                  />
                  <div className="migration-videocall-info__instructions-container--paragraph">
                    <div className="migration-videocall-info__instructions-container--title">
                      {formatText(element.title)}
                    </div>
                    <div className="migration-videocall-info__instructions-container--subtitle">
                      {formatText(element.subtitle)}
                    </div>
                  </div>
                </div>
              </Fragment>
            ))}
          </div>
          <OKMessage type="informative" title={formatText(videocallInfoKeys.infoMessageTitle)}>
            <FormattedText value={videocallInfoKeys.infoMessageDescription} />
          </OKMessage>
        </div>
      )}
    </OKLayoutMigration>
  );
};

VideocallInfo.propTypes = {
  handleChangeMigrationState: PropTypes.func.isRequired,
  handleExitLeaveModal: PropTypes.func.isRequired,
};
